import React,{ useState } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Card from 'react-bootstrap/Card';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import LoaderButton from '../../../components/LoaderButton/LoaderButton';
import { Auth } from 'aws-amplify';

import * as actions from '../../../store/actions/index';
import './Login.scss';

// const header = require('../../../assets/images/ipsum_city_header.png');
const header = require(process.env.REACT_APP_LOGIN_HEADER)

const Login = (props) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
	// confirmation modal
	const [showModal, setShowModal] = useState(false);
    const [confirmationEmail, setConfirmationEmail] = useState('');
	const [confirmationCode, setConfirmationCode] = useState('');
	const [confirmationError, setConfirmationError] = useState('');
	// reset password modal
	const [showResetModal, setShowResetModal] = useState(false);
    const [resetEmail, setResetEmail] = useState('');
    const [resetCode, setResetCode] = useState('');
    const [resetError, setResetError] = useState('');
	const [newPassword, setNewPassword] = useState('');

	function validateEmail(email){
		if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email))
		  return true;
		else
		  return false;
	}

	const validateForm = () => {
		return email.length > 0
				&& validateEmail(email)
				&& password.length > 0;
	}

	const validateConfirmationForm = () => {
		return confirmationEmail.length > 0
				&& validateEmail(confirmationEmail)
				&& confirmationCode.length > 0;
	}

	const validateResetForm = () => {
		return resetEmail.length > 0
				&& validateEmail(resetEmail)
				&& resetCode.length > 0
				&& newPassword.length > 0;
	}

	const handleCloseModal = () => {
		setShowModal(false);
		setConfirmationEmail('');
		setConfirmationCode('');
	};

	const handleCloseResetModal = () => {
		setShowResetModal(false);
		setResetEmail('');
		setResetCode('');
		setNewPassword('');
	};

	const handleSubmit = async (event) => {
		event.preventDefault();
		try {
			await props.onAuth(email, password);
			await props.onViewPerm(email);
			props.onSetAuthRedirectPath();
		}catch (e){
			console.log(e);
		}

	};

	const handleConfirmationSubmit = async (event) => {
		event.preventDefault();
		try {
			await Auth.confirmSignUp(confirmationEmail, confirmationCode);
			handleCloseModal();
		} catch (e) {
			setConfirmationError(e.message);
		}
	};

	const handleResetSubmit = async (event) => {
		event.preventDefault();
		try {
			await Auth.forgotPasswordSubmit(resetEmail, resetCode, newPassword);
			handleCloseResetModal();
		} catch (e) {
			setResetError(e.message);
		}
	};

	let errorMessage = null;
	if (props.error){
		errorMessage = (
			<p className="alert alert-danger" role="alert">
				{props.error}
			</p>);
	}

	let ConfirmErrorMsg = null;
	if (confirmationError){
		ConfirmErrorMsg = (
		<p className="alert alert-danger" role="alert">
		{confirmationError}
		</p>);
	}

	let ResetErrorMsg = null;
	if (resetError){
		ResetErrorMsg = (
		<p className="alert alert-danger" role="alert">
		{resetError}
		</p>);
	}

	let authRedirect = null;
	if (props.isAuthenticated) {
		const referrer = (props.location.state && props.location.state.referrer) || props.authRedirectPath;
		authRedirect = <Redirect to={referrer}/>
	}

	return (
		<div className="Login">
			{authRedirect}
			<form onSubmit={handleSubmit}>
				<Card className="card" >	
					<Card.Header className="header">
						<img className="p-2" alt="" src={header} width="90%"/>
					</Card.Header>				
					<Card.Body className="mb-4">
					<div className="col-md-12">
						<Form.Group controlId="email" className="mb-3">
							<Form.Label>Email</Form.Label>
							<Form.Control  autoFocus type="email" value={email} onChange={(e) => setEmail(e.target.value)} className="frm-input" />
						</Form.Group>
						<Form.Group controlId="password" className="mb-3">
							<Form.Label>Password</Form.Label>
							<Form.Control  value={password} onChange={(e) => setPassword(e.target.value)} type="password" className="frm-input"/>
						</Form.Group>
						<LoaderButton
							block
							variant="default"
							disabled={!validateForm()}
							type="submit"
							isLoading={props.loading}
							text="Login"
							loadingText="Logging in…"
							className="LoaderButtonLogin"
						/>

						<div className="my-2">
						{errorMessage}
						</div>
						<div className="b-link-div">
							<Button className="b-link p-0" variant="link" onClick={() => setShowModal(true)}>
								Confirmation Code
							</Button><br/>
							<Button className="b-link p-0" variant="link" onClick={() => setShowResetModal(true)}>
								Forgot Password
							</Button>
						</div>
					</div>
					</Card.Body>
				</Card>
			</form>
			{/* Confirm Email Modal */}
			<Modal centered className="text-dark" show={showModal} onHide={handleCloseModal} animation={false} >
				<Modal.Header className="bg-warning" closeButton>
				<Modal.Title><h4>Confirm Email</h4></Modal.Title>
				</Modal.Header>
				<form>
				<Modal.Body>
					<Form.Group controlId="confirmationEmail">
						<Form.Label>Email</Form.Label>
						<Form.Control autoFocus type="email" value={confirmationEmail} onChange={(e) => setConfirmationEmail(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="confirmationCode">
						<Form.Label>Confirmation Code</Form.Label>
						<Form.Control type="text" value={confirmationCode} onChange={(e) => setConfirmationCode(e.target.value)} />
						<Form.Text id="chkEmailCode" muted>Please check your email for the code.</Form.Text>
					</Form.Group>
					{ConfirmErrorMsg}
				</Modal.Body>
				</form>
				<Modal.Footer>
				<Button className="m-0 mr-2" variant="warning" disabled={!validateConfirmationForm()} onClick={handleConfirmationSubmit}>
					Send
				</Button>
				<Button className="m-0" variant="secondary" onClick={handleCloseModal}>
					Close
				</Button>
				</Modal.Footer>
			</Modal>
			{/* Forgot Password Modal */}
			<Modal centered className="text-dark" show={showResetModal} onHide={handleCloseResetModal} animation={false} >
				<Modal.Header className="bg-warning" closeButton>
				<Modal.Title><h4>Reset Password</h4></Modal.Title>
				</Modal.Header>
				<form>
				<Modal.Body>
					<Form.Group controlId="resetEmail">
						<Form.Label>Email</Form.Label>
						<Form.Control autoFocus type="email" value={resetEmail} onChange={(e) => setResetEmail(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="resetCode">
						<Form.Label>Reset Code</Form.Label>
						<Form.Control type="text" value={resetCode} onChange={(e) => setResetCode(e.target.value)} />
					</Form.Group>
					<Form.Group controlId="newPassword" className="mb-3">
							<Form.Label>New Password</Form.Label>
							<Form.Control value={newPassword} onChange={(e) => setNewPassword(e.target.value)} type="password" />
							<Form.Text id="chkAdmCode" muted>Please ask the Administrator for the code.</Form.Text>
					</Form.Group>
					{ResetErrorMsg}
				</Modal.Body>
				</form>
				<Modal.Footer>
				<Button className="m-0 mr-2" variant="warning" disabled={!validateResetForm()} onClick={handleResetSubmit}>
					Send
				</Button>
				<Button className="m-0" variant="secondary" onClick={handleCloseResetModal}>
					Close
				</Button>
				</Modal.Footer>
			</Modal>
		</div>

	);
}

const mapStateToProps = state => {
    return {
        loading: state.auth.loading,
        error: state.auth.error,
        isAuthenticated: state.auth.token !== null,
		authRedirectPath: state.auth.authRedirectPath,
		userId: state.auth.userId
    };
};

// check authentication
const mapDispatchToProps = dispatch => {
    return {
        onAuth: ( email, password ) => dispatch( actions.auth( email, password ) ),
        onSetAuthRedirectPath: () => dispatch(actions.setAuthRedirectPath('/')),
		onViewPerm: (user) => dispatch(actions.setViewPerm(user))
    };
};

export default connect( mapStateToProps, mapDispatchToProps )( Login );